import axios from "../axios";
import { Cookies } from "react-cookie";
const endPoint = `/crm/freelancer/`;

const cookie = new Cookies();

export const getUsers = async (page, role, search) => {
  const token = cookie.get("crm");
  return await axios.get(
    `${endPoint}associated?page=${page}&role=${role}&search=${search}`,
    {
      headers: { Authorization: token },
    },
  );
};

export const getAllUsers = async () => {
  const token = cookie.get("crm");
  return await axios.get(`${endPoint}all`, {
    headers: { Authorization: token },
  });
};

export const createAssociate = async (signupForm) => {
  const token = cookie.get("crm");
  return await axios.post(`${endPoint}create`, signupForm, {
    headers: { Authorization: token },
  });
};

export const getroles = async () => {
  const token = cookie.get("crm");
  return await axios.get(`${endPoint}roles`, {
    headers: { Authorization: token },
  });
};

export const getMarketers = async () => {
  const token = cookie.get("crm");
  return await axios.get(`${endPoint}marketeres`, {
    headers: { Authorization: token },
  });
};
export const getAssignements = async (id) => {
  const token = cookie.get("crm");
  return await axios.get(`${endPoint}assignements/${id}`, {
    headers: { Authorization: token },
  });
};

export const enableUser = async (id, enable) => {
  const token = cookie.get("crm");
  return await axios.put(
    `${endPoint}enable?id=${id}&enable=${enable}`,
    {},
    {
      headers: { Authorization: token },
    },
  );
};
